import { Brand } from '@deltasierra/type-utilities';

export type ReportColor = Brand<string, 'ReportColor'>;

export const ReportColors: ReadonlyArray<ReportColor> = [
    '#6A30FA' as ReportColor,
    '#FF4F4C' as ReportColor,
    '#FF78D6' as ReportColor,
    '#09696B' as ReportColor,
    '#F5CF47' as ReportColor,
] as const;

/**
 * Unused... Currently cycling through the colours is a better option
 *
 * @returns a colour string
 * @deprecated see above
 */
export function generateReportColor(): ReportColor {
    return `#${Math.floor(Math.random() * 16777215)
        .toString(16)
        .padStart(6, '0')}` as ReportColor;
}

export function getReportColor(index: number): ReportColor {
    return ReportColors[index % ReportColors.length];
}
